import Layout from '@4c/layout';
import styled from 'astroturf';
import Button from './Button';
import Heading from './Heading';
import Text from './Text';
import { useTheme } from './ThemeContext';
/**
 * A component for rendering empty states, such as lists or pages.
 */

const BlankSlate = /*#__PURE__*/styled(Layout, null, {
  displayName: "BlankSlate",
  styles: require("./BlankSlate.module.scss"),
  attrs: props => ({ ...props,
    direction: 'column',
    align: 'center'
  }),
  vars: []
});
const BlankSlateImg = /*#__PURE__*/styled('img', null, {
  displayName: "BlankSlateImg",
  styles: require("./BlankSlate-BlankSlateImg.module.scss"),
  attrs: null,
  vars: []
});
const BlankSlateTitle = /*#__PURE__*/styled(Heading, null, {
  displayName: "BlankSlateTitle",
  styles: require("./BlankSlate-BlankSlateTitle.module.scss"),
  attrs: null,
  vars: []
});
const BlankSlateBody = /*#__PURE__*/styled(Text, null, {
  displayName: "BlankSlateBody",
  styles: require("./BlankSlate-BlankSlateBody.module.scss"),
  attrs: props => ({ ...props,
    as: 'p',
    color: 'headline',
    theme: useTheme()
  }),
  vars: []
});
const BlankSlateAction = /*#__PURE__*/styled(Button, {
  allowAs: true
}, {
  displayName: "BlankSlateAction",
  styles: require("./BlankSlate-BlankSlateAction.module.scss"),
  attrs: null,
  vars: []
});
export default Object.assign(BlankSlate, {
  Img: BlankSlateImg,
  Title: BlankSlateTitle,
  Body: BlankSlateBody,
  Action: BlankSlateAction
});